import React from "react";

const Modal = (props) => {
  return (
    <div id="modal-container">
      <div id="modal-inner">
        <span id="close-button" onClick={() => props.setModal("")}>
          <img src="/assets/close.svg" alt="close modal"></img> Close
        </span>
        {(() => {
          switch (props.modal) {
            case "hitness":
              return (
                <>
                  <h2>Hitness Club</h2>
                  <div>
                    Hitness Club is »a TV station art project based on
                    open-source software«. It's located at
                    Hermann-Liebmann-Straße 86 in Leipzig and at
                    <strong>www.hitness.club</strong> in the internet. It's a
                    participative project where everyone is invited to visit,
                    develop ideas and implement those. All of Hitness Club's
                    content is licensed under Creative Commons license, public
                    domain or is their own production.
                  </div>
                  <ul>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://hitness.club"
                      >
                        website: hitness.club
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.instagram.com/hitness.club"
                      >
                        IG: hitness.club
                      </a>
                    </li>
                  </ul>
                </>
              );
            case "algorave":
              return (
                <>
                  <h2>Algorave</h2>
                  <div>
                    Algorave is a global and decentralized form of events -
                    wittingly described as »sounds wholly or predominantly
                    characterised by the emission of a succession of repetitive
                    conditionals.« At an Algorave rave-link music and visuals
                    are created using programming languages and open-source
                    tools. The source code that's used for these A/V experiences
                    is shared with the audience via projection so as to not hide
                    the creative process from the audience. The first Algroaves
                    where held in 2012 in Sheffield, Uk and quickly spread all
                    over the world.
                  </div>
                  <div
                    style={{
                      textDecoration: "underline",
                      textDecorationStyle: "wavy",
                    }}
                  >
                    What is Algorave? | Alexandra Cardenas at rC3 NOWHERE
                  </div>
                  <iframe
                    title="What is Algorave? | Alexandra Cardenas at rC3 NOWHERE"
                    src="https://media.ccc.de/v/rc3-2021-chaoszone-345-what-is-algorave/oembed"
                    frameborder="0"
                    allowfullscreen
                  ></iframe>
                  <ul>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://algorave.com/"
                      >
                        ALGORAVE website
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.instagram.com/algorave/"
                      >
                        IG: algorave
                      </a>
                    </li>
                    {/* <li><a           target="_blank"
          rel="noopener noreferrer"href="https://esoteric.codes/blog/interview-with-alex-mclean">Interview with Alex McLean at esoteric.codes</a></li> */}
                  </ul>
                </>
              );
            case "TOPLAP":
              return (
                <>
                  <h2>TOPLAP</h2>
                  <div>
                    TOPLAP stands for »Temporal Organisation for the Permanence
                    of Live Artistic Programming« (or »laptop« with the
                    syllables swapped). It's a global organization of people
                    working creatively with programming languages for the
                    production of algorithmic and generative audio and visual
                    experiences. TOPLAP is spread across so-called »nodes«, i.e.
                    several local associations{" "}
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://toplap.org/nodes/"
                    >
                      as listed here
                    </a>
                    .
                  </div>
                  <iframe
                    src="https://player.vimeo.com/video/20241649?h=dbd52bfeff"
                    title="'Show Us Your Screens' - A Documentary about live coding practise by Louis McCallum and Davy Smith"
                    frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                  <ul>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="http://toplap.org/"
                      >
                        TOPLAP website
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://tidalcycles.org/docs/around_tidal/toplap_manifesto/"
                      >
                        The TOPLAP Manifesto
                      </a>
                    </li>
                  </ul>
                </>
              );
            case "parkellipsen":
              return (
                <>
                  <h2>parkellipsen & z0rg</h2>
                  <img
                    src="/assets/041_KAT2122_resized.jpg"
                    alt="parkellipsen with an umbrella"
                  ></img>
                  <span>(c) Katja Goljat, Matjaž Rušt</span>
                  <div>
                    »Niklas Reppel is a programmer, live coder, sound artist,
                    composer, musician, and committed eclecticist. He has been
                    based in Barcelona since 2017, where he found a home in the
                    local TOPLAP node. He has performed as a live coder
                    nationally and internationally, and has been a regular
                    contributor to the International Conference on Live Coding
                    since its inception in 2015. Having played in a variety of
                    music ensembles in the distant past (ranging from
                    jam-oriented rock bands to contemporary chamber music groups
                    and everything in between), his current (sound) art practice
                    draws influence from improvisational music, the the everyday
                    sound around him, and the beauty of Markov chains. He spends
                    a lot of time making live coding environments to facilitate
                    his workflows in sound art, improvisational performance on
                    multichannel setups, or plain old algorave.«
                  </div>
                  <ul>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://parkellipsen.de"
                      >
                        parkellipsen | website
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.youtube.com/@ellipsenpark"
                      >
                        parkellipsen | YT
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://github.com/the-drunk-coder"
                      >
                        parkellipsen | Github
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://ellipsenpark.bandcamp.com/"
                      >
                        parkellipsen | BC
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://vimeo.com/parkellipsen"
                      >
                        parkellipsen | Vimeo
                      </a>
                    </li>
                  </ul>
                  <img
                    src="/assets/DSC00394.webp"
                    alt="z0rg at a laptop in a live setting"
                  ></img>
                  <div>
                    Sébastien Maire aka z0rg uses shader livecoding to produce
                    generative visuals and VJ performances involving a rich
                    universe ranging from SF scenes to vivid and abstract acid
                    visuals.
                  </div>
                  <ul>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://linktr.ee/z0rg"
                      >
                        z0rg | linktree
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.youtube.com/@ellipsenpark"
                      >
                        YT
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://github.com/the-drunk-coder"
                      >
                        Github
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://ellipsenpark.bandcamp.com/"
                      >
                        BC
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://vimeo.com/parkellipsen"
                      >
                        Vimeo
                      </a>
                    </li>
                  </ul>
                </>
              );
            case "tmo":
              return (
                <>
                  <h2>Timo Hoogland aka. _t.mo</h2>
                  <img
                    src="/assets/performance-credit_by-Pauluz-3-edit.jpg"
                    alt="Timo in front of a projection with programming code"
                  ></img>
                  <span>photo by @by_pauluz</span>
                  <ul>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://youtu.be/nnhLPL-kKMs?si=hO5z-u0iQbrkl3xV"
                      >
                        yt
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.instagram.com/tmhglnd/"
                      >
                        ig
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://timohoogland.bandcamp.com/"
                      >
                        bc
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://github.com/tmhglnd"
                      >
                        gh
                      </a>
                    </li>
                  </ul>
                </>
              );
            case "loopier":
              return (
                <>
                  <h2>Loopier</h2>
                  <img
                    src="/assets/rogerpibernat-by-Katja_Goljat_KAT4162.jpg"
                    alt="Timo in front of a projection with programming code"
                  ></img>
                  <span>photo by Katia Goljat</span>
                  <div>
                    Loopier (Roger Pibernat) is an illustrator and live coding
                    musician and visualist with poetic taste. He developed the
                    *Superfm* synth for TydalCycles, the live coding dialect for
                    SuperCollider Živa and --with Glen Fraser-- a playground for
                    live coded animation named Animatron. He is currently an
                    active member of the live coding community in Barcelona.
                  </div>
                  <ul>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.rogerpibernat.com/"
                      >
                        web
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://github.com/loopier"
                      >
                        github
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.youtube.com/@rogerpibernat"
                      >
                        youtube
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://post.lurk.org/@loopier"
                      >
                        mastodon
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.instagram.com/rogerpibernat/ "
                      >
                        instagram
                      </a>
                    </li>
                  </ul>
                </>
              );
            case "mrreason":
              return (
                <>
                  <h2>MrReason</h2>
                  <img src="/assets/me.jpeg" alt="Thomas Grund in nature"></img>
                  <div>
                    MrReason (Thomas Grund) is a live coding musician, electric
                    guitarist and software engineer from Leipzig/Germany. He has
                    actively contributed to the TidalCycles community since
                    2020. Noteworthy are the development and release of
                    TidalLooper, SuperDirtMixer, and TidalVST, widely used in
                    diverse projects. MrReason is constantly working on his idea
                    of combining complex arrangements with live coding and live
                    looping to bring his own vision of a live performance to the
                    stage. He has also recently joined the Leipzig-based group
                    LOLL2, which is making the upcoming Algorave possible.
                  </div>
                  <ul>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.mrreason.org/"
                      >
                        web
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://github.com/thgrund"
                      >
                        github
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.youtube.com/channel/UCYn5oKcBQtPVWKznEMCNqoA"
                      >
                        youtube
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.instagram.com/mrreasonmusic/"
                      >
                        instagram
                      </a>
                    </li>
                  </ul>
                </>
              );
            case "staxl":
              return (
                <>
                  <h2>Staxl</h2>
                  <img
                    src="/assets/staxl_webcam_photo.png"
                    alt="Staxl in an old-school webcam HUD"
                  ></img>
                  <div>
                    Staxl is a livecoding/algorave artist based in Leipzig,
                    Germany. In his live sets he's using programming languages
                    and software to generate rhythmic, algorithmic music with a
                    lot of unpredictabilities, squelchy sounds, glitchy breaks,
                    abstracted samples, clubby beats as well as unusual,
                    abrasive sounds, jungle/breakcore vibes and hard basses -
                    much like in his more recent DJ sets.
                  </div>
                  <ul>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://and-kal.github.io/livecoding/
                            "
                      >
                        web
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://github.com/and-kal"
                      >
                        github
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://soundcloud.com/staxl"
                      >
                        soundcloud
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://sonomu.club/@staxl"
                      >
                        mastodon
                      </a>
                    </li>
                  </ul>
                </>
              );
            case "pondskater":
              return (
                <>
                  <h2>Pondskater</h2>
                  <img
                    src="/assets/20_10_2023_Offchurch_Mace.jpg"
                    alt="Pondskater in front of a livecoding envirnoment projection"
                  ></img>
                  <div>
                    The current Pondskater programme includes different types of
                    electronic music. Complex rhythms are the basis of
                    Pondskater's dark downbeat. Melodic elements hint at African
                    and Asian influences. Without touching the dancefloor,
                    overlapping patterns of acoustic percussion and synthesizers
                    become entangled in the branches of erratic voices. A
                    musical tightrope walk between club and experiment. Since
                    2019, Düsseldorf-based musician Axel Ganz aka Pondskater has
                    been working with live coding, a technique that focuses on
                    writing source code and interactive programming in
                    improvised form. An elementary part of his performance is to
                    make the writing process of the source code visible to the
                    audience through a spatial projection of his monitor. In
                    addition, there are further visual levels designed by the
                    Düsseldorf artist Katja Stuke.
                  </div>
                  <ul>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.pondskater.org/"
                      >
                        web
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://pondskater-music.bandcamp.com/"
                      >
                        bandcamp
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.instagram.com/pondskater_music/"
                      >
                        instagram
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://soundcloud.com/pondskater/pondskater-live-arkaoda-berlin-01-11-2023"
                      >
                        Recent live set @ Arkaoda, Berlin
                      </a>
                    </li>
                  </ul>
                </>
              );
            case "linasol":
              return (
                <>
                  <h2>Linalab & Sol Sarratea</h2>
                  <img
                    src="/assets/lina_sol.jpg"
                    alt="Linalab & Sol Sarratea performing live"
                  ></img>
                  <div>
                    Sol Sarratea is a Leipzig-based shader and livecoding artist
                    working at the intersection of math, art, and technology and
                    combining technical expertise with artistic sensibilities in
                    order to create impactful experiences.
                  </div>
                  <div>
                    »Linalab is a multiple singularity, it's a whole and unity,
                    it is a solitary sound, a note, a frequency that when
                    remains in time becomes more complex, becomes entangled,
                    becomes noise, melody, song and then, silence.«
                  </div>
                  <div>
                    At Binary Blast, the two of them will team up and present a
                    set of livecoded shader visuals and algorithmically
                    generated sound sequences.
                  </div>
                  <ul>
                    <li>
                      <iframe
                        width="560"
                        height="315"
                        src="https://www.youtube-nocookie.com/embed/Te_M_BissQU?si=S9rcL9nMzrJvOnyG"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen
                      ></iframe>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://solsarratea.world/"
                      >
                        Sol Sarratea | website
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.instagram.com/linalab"
                      >
                        Linalab | instagram
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://linktr.ee/linalab"
                      >
                        Linalab | linktree
                      </a>
                    </li>
                  </ul>
                </>
              );
            case "traumazone":
              return (
                <>
                  <h2>TraumaZone</h2>
                  <img
                    src="/assets/photo_2023-11-08_10.38.35.jpeg"
                    alt="profile shot of Fyodor and Ksenia"
                  ></img>
                  <div>
                    TraumaZone is a duo of a media and a sound artist based
                    between Berlin and Leipzig, Germany.The goal of our
                    collective is to encourage contemplation on the impact
                    design and communication have on the society, urging to
                    reflect on the shared responsibility of creating spaces that
                    accommodate all individuals, regardless of their physical or
                    cultural attributes. We examine social interactions within
                    public spaces through the ideas of a maze as a communication
                    tool and a human body as a socio-political medium.
                  </div>
                  <ul>
                    <li>
                      <iframe
                        width="560"
                        height="315"
                        src="https://www.youtube-nocookie.com/embed/iAtbcZn1z58?si=3R1nlzbVQQ4V96TU"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen
                      ></iframe>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="http://fyodorstepanov.tilda.ws"
                      >
                        website | Fyodor Stepanov
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="http://kseniabashmakova.tilda.ws/"
                      >
                        website | Ksenia Bashmakova
                      </a>
                    </li>
                  </ul>
                </>
              );
            case "nervousdata":
              return (
                <>
                  <h2>nervousdata</h2>
                  <img
                    src="/assets/meerhoff_jasmin--portrait.jpg"
                    alt="the artists nervousdata in the nature"
                  ></img>
                  <div>
                    nervousdata is an alias, an online presence and a publishing
                    space for experimental literature, sounds and other works.
                    When livecoding, her computer becomes a digestive machine
                    for text and sound: slicing, grinding and pressing.
                    Power-Cut-Ups and Lumpen Poetics.
                  </div>
                  <ul>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://nervousdata.com"
                      >
                        website
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://sonomu.club/@jine"
                      >
                        mastodon
                      </a>
                    </li>
                  </ul>
                </>
              );
            case "computerpoetry":
              return (
                <>
                  <h2>computer-aided poetry ¦¦ show-and-tell by nervousdata</h2>
                  <img
                    src="/assets/accesswithout.gif"
                    alt="english text, fragmented"
                  ></img>
                  <span>›Access Without‹ (2020) by nervousdata</span>
                  <div>
                    We are happy to have <strong>nervousdata</strong> not only
                    play a liveset at our algorave on December 1, but also
                    present her creative coding work and her programmatic
                    approach to generative poetry on December 2.
                  </div>
                  <div>
                    The presentation will show two ways (based on nervousdata's
                    personal projects) of using Bash/Shell scripting to produce
                    both concrete poetry (text as image) and Dada-inspired poems
                    based on automated auto-correction. The presentation also
                    includes a tiny bit of computer programming history.
                  </div>
                  <div>
                    This presentations (same like all the others on Dec 2) are
                    for free. (You can donate some money, if you like, but it's
                    optional.)
                  </div>
                  <div>
                    Bringing your laptop is encouraged, so you can try things
                    out for yourself.
                  </div>
                  <ul>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://nervousdata.com"
                      >
                        website | nervousdata
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://sonomu.club/@jine"
                      >
                        mastodon | nervousdata
                      </a>
                    </li>
                  </ul>
                </>
              );
            case "megra":
              return (
                <>
                  <h2>Mégra ¦¦ presentation and workshop by parkellipsen</h2>
                  <img
                    src="/assets/1700930305.png"
                    alt="the Mégra livecoding language running in a dedicated editor"
                  ></img>
                  <div>
                    Mégra is a mini-language to make music with variable-order
                    Markov chains and some other stochastic shenanigans. This
                    presentation will give a brief introduction into the
                    language distinctive features.
                  </div>
                  <div>
                    The presentation is for free and you don't need to bring
                    anything. If you have your computer with you though, you can
                    try out Mégra right away.
                  </div>
                  <ul>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://github.com/the-drunk-coder/megra.rs"
                      >
                        Mégra Github repo
                      </a>
                    </li>
                  </ul>
                </>
              );
            case "databending":
              return (
                <>
                  <h2>
                    Databending/Datamoshing ¦¦ introduction subsequent hackathon
                  </h2>
                  {/* <img
                    src="/assets/1700930305.png"
                    alt="the Mégra livecoding language running in a dedicated editor"
                  ></img> */}
                  <div>
                    On Saturday afternoon (Dec 2) we will introduce you to the
                    glitched-out world of{" "}
                    <strong>databending and datamoshing</strong> by showing you
                    how to use a Hex Editor to manipulate videos, images and
                    audio files. We'll also sow you some dedicated datamoshing
                    tools like{" "}
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://supermosh.github.io/"
                    >
                      Supermosh
                    </a>{" "}
                    and ways how to misuse certain software that you know for
                    databending purposes. People unafraid of code can also learn
                    how to use scripting languages like{" "}
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.lua.org/"
                    >
                      Lua
                    </a>{" "}
                    for moshing out.
                  </div>
                  <div>
                    If you are already familiar with datamoshing, feel free to
                    introduce your approach to use and share your skills and
                    experiences.
                  </div>
                  <ul>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="http://nickbriz.com/databending101/"
                      >
                        Datamoshing 101 by Nick Briz
                      </a>
                    </li>
                  </ul>
                </>
              );
            case "hackathon":
              return (
                <>
                  <h2>Binary Blast Hackathon</h2>
                  <div>
                    After the workshops and presentations, we'll take the
                    reamaining afternoon to explore the different things we've
                    been introduced to in a little hackathon, where we can form
                    study groups and work together or independently on
                    databending and shell scripting or explore Mégra or do
                    whatever we like and then present our results to each other
                    (if we feel like).
                  </div>
                </>
              );
            default:
              return <></>;
          }
        })()}
      </div>
    </div>
  );
};
export default Modal;
